import { IAnalyticsInsight, IAnalyticsSpaceUserStat } from 'src/app/models/analytics';
import { Visibility } from 'src/app/models/session';
import { ShareSnippetsSettings } from 'src/app/models/user';
import {
  ISpaceRecordingInsights,
  ISpaceRecordingSnippets,
  RecordingSummary,
  RecordingSummaryStatus,
  SpaceRecording,
  SpaceRecordingInsightStatus,
  SpaceRecordingSnippetsStatus,
} from 'src/app/models/space-recording';

export interface AnalyticsSessionSpaceInstitutionSettings {
  crEnableHostDeletion?: boolean;
  crEnableDownloads?: boolean;
  crEnablePublicRecordings?: boolean;
  crForceAdminOnlyAccess?: boolean;
  shareSnippetsSettings?: ShareSnippetsSettings;
}

export interface AnalyticsSessionSpaceInstitution {
  _id: string;
  settings: AnalyticsSessionSpaceInstitutionSettings;
}

export interface AnalyticsSessionSpaceRoom {
  uid: string;
  name: string;
}

export interface AnalyticsSessionSpaceSiteSettings {
  shareSnippetsSettings?: ShareSnippetsSettings;
}

export interface AnalyticsSessionSpace {
  _id: string;
  site?: string;
  title?: string;
  visibility?: Visibility;
  institution?: AnalyticsSessionSpaceInstitution;
  siteSettings?: AnalyticsSessionSpaceSiteSettings;
  hostIds: string[];
  rooms: AnalyticsSessionSpaceRoom[];
}

export type AnalyticsSessionRecording = Omit<SpaceRecording, 'spaceId' | 'sessionId'> & {
  downloadLink?: string;
};

export interface AnalyticsSessionEvent {
  id?: string;
  title: string;
  startTime?: string;
  endTime?: string;
  organizerIds?: string[];
  attendeeIds?: string[];
  unlistedAttendeeIds?: string[];
}

export interface IAnalyticsSessionDetails extends IAnalyticsInsight {
  attendees: IAnalyticsSpaceUserStat[];
  space: AnalyticsSessionSpace;
  recordings: AnalyticsSessionRecording[];
  insights?: ISpaceRecordingInsights[];
  sessionSummary?: RecordingSummary | null;
  snippets?: ISpaceRecordingSnippets[];
  reportStatus?: {
    coachingStatus?: SpaceRecordingInsightStatus;
    summaryStatus?: RecordingSummaryStatus;
    snippetsStatus?: SpaceRecordingSnippetsStatus;
  };
  event?: AnalyticsSessionEvent;
}

export interface APIAnalyticsSessionsDetailsResponse {
  sessions: IAnalyticsSessionDetails[];
  totalRecords: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
}

export interface AnalyticsSessionsDetailsFilters {
  dateStart?: Date;
  dateEnd?: Date;
  spaceIds?: string[];
  attendees?: string[];
  hasCalls?: boolean;
  hasRecording?: boolean;
}

export enum SessionDetailsEntrySource {
  SESSIONS_TAB = 'sessions-tab',
  SPACE_SESSIONS = 'space-sessions',
  DIRECT_LINK = 'direct-link',
  SINGLE_TEACHER = 'single-teacher',
}
